exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wxcord[data-v-c51be87c]{width:100%;font-size:12px;margin:0 20px}", ""]);

// exports
